import {IMAGE_SERVER_URL, IMAGE_SERVER_URL_ORIGINAL} from "../config";

export const useAppImage = () => {
    const getImageUrl = (templateId: string, height?: number | undefined) => {
        if (height === undefined) {
            return IMAGE_SERVER_URL_ORIGINAL.replace('{templateId}', templateId);
        }

        return IMAGE_SERVER_URL.replace('{templateId}', templateId).replace(
            '{height}',
            height.toString(),
        );
    };

    return {getImageUrl};
}
